import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { meApi, type BootstrapResponse } from '../../api/endpoints/me';

/**
 * Hook calling `POST /api/me/bootstrap` po authenticated.
 * Returns BootstrapResponse z `hasUsername` flag — frontend username gate (T27c) wires off it.
 */
export function useBootstrap() {
  const { isAuthenticated } = useAuth0();

  return useQuery<BootstrapResponse>({
    queryKey: ['me', 'bootstrap'],
    queryFn: () => meApi.bootstrap(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
